import { PropostaConfiguracao } from 'models/PropostaConfiguracao';
import { PropostaDescontoComissao } from 'models/PropostaDescontoComissao';
import { createContext, useContext, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  FormGroup,
  InputGroup,
  Modal,
  ModalBody,
  Row,
} from 'reactstrap';
import api from 'services/api';
import FloatingButton from 'components/FloatingButton';
import { PropostaVersao } from 'models/PropostaVersao';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import OpcaoMostrarBotoes from 'staticData/OpcaoMostrarBotoes';
import { FaCheckCircle } from 'react-icons/fa';
import Select, { SingleValue } from 'react-select';
import Material from 'models/Material';
import { TextField } from '@material-ui/core';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { useQuery, useQueryClient } from 'react-query';
import { PropostaContext } from '../..';

import { DownloadPlanilha } from './components/DownloadPlanilha';
import PropostaConfiguracaoMaterial from './components/PropostaConfiguracaoMaterial';
import PropostaMaterialAvulso from './components/PropostaMaterialAvulso';
import ImportarExcel, { Opcoes } from '../ImportarExcel';
import PropostaMaterialImportado from './components/PropostaMaterialImportado';
import './style.css';

interface Dados {
  aprovacaoNecessaria: boolean;
}

interface MateriaisContext {
  valorItens: number | null;
  valorFrete: number | null | undefined;
  valorFinal: number | null;
  valorFinalDolar: number | null;
  setValorItens: (valor: number | null) => void;
  setValorFrete: (valor: number | undefined) => void;
  setValorFinal: (valor: number | null) => void;
  setValorServico: (valor: number | null) => void;
  setValorDesconto: (valor: number | null) => void;
  setValorFinalDolar: (valor: number | null) => void;
  setValorPercentualFrete: (valor: number | null) => void;
  loadingMateriais: boolean;
  setLoadingMateriais: (valor: boolean) => void;
  setTriggerMaterialCheck: (value: boolean) => void;
  isMaterialValid: boolean;
  acessoLimitado: boolean;
  listaDescontoComissao: PropostaDescontoComissao[];
  atualizarPrecificacao: boolean;
  setAtualizarPrecificacao: (value: boolean) => void;
  recalculandoProposta: boolean;
  setRecalculandoProposta: (value: boolean) => void;
  descontoSelecionado: string | null;
  setDescontoSelecionado: (valor: string | null) => void;
  descontoMaximo: number | null;
  setDescontoMaximo: (valor: number | null) => void;
  valorLicenciamento: number | undefined;
  setValorLicenciamento: (valor: number | undefined) => void;
  valorTopografia: number | undefined;
  setValorTopografia: (valor: number | undefined) => void;
  valorOutros: number | undefined;
  setValorOutros: (valor: number | undefined) => void;
  isLicenciamentoPercentual: boolean;
  setIsLicenciamentoPercentual: (value: boolean) => void;
  isTopografiaPercentual: boolean;
  setIsTopografiaPercentual: (value: boolean) => void;
  isOutrosPercentual: boolean;
  setIsOutrosPercentual: (value: boolean) => void;
  isFretePercentual: boolean;
  setIsFretePercentual: (value: boolean) => void;
  valorDolarCambial: number;
  setValorDolarCambial: (valor: number) => void;
  valorDespesaDespachante: number;
  setValorDespesaDespachante: (valor: number) => void;
  valorSeguroFrete: number;
  setValorSeguroFrete: (valor: number) => void;
  valorDolarParametro: number;
  setValorDolarParametro: (valor: number) => void;
  percentualAssistenciaTecnica: number;
  setPercentualAssistenciaTecnica: (valor: number) => void;
  percentualTaxaFlat: number;
  setPercentualTaxaFlat: (valor: number) => void;
  percentualComissao: number;
  setPercentualComissao: (valor: number) => void;
  percentualAjusteComissao: number;
  setPercentualAjusteComissao: (valor: number) => void;
  percentualIndicadorNegocio: number;
  setPercentualIndicadorNegocio: (valor: number) => void;
  percentualComissaoReceber: number;
  setPercentualComissaoReceber: (valor: number) => void;
  percentualServicos: number;
  setPercentualServicos: (valor: number) => void;
  percentualICMS: number;
  setPercentualICMS: (valor: number) => void;
  percentualPISCofins: number;
  setPercentualPISCofins: (valor: number) => void;
  percentualIPI: number;
  setPercentualIPI: (valor: number) => void;
  percentualST: number;
  setPercentualST: (valor: number) => void;
  isSaveRequired: boolean;
  setIsSaveRequired: (value: boolean) => void;
  salvandoDifal: boolean;
  setSalvandoDifal: (value: boolean) => void;
  idBancoFinanciamentoSelecionado: string;
  setIdBancoFinanciamentoSelecionado: (valor: string) => void;
  linhaCreditoSelecionado: number;
  setLinhaCreditoSelecionado: (valor: number) => void;
  formatoBancoSelecionado: string;
  setFormatoBancoSelecionado: (valor: string) => void;
  isPercentualLicenciamento: boolean;
  setIsPercentualLicenciamento: (value: boolean) => void;
  isPercentualTopografia: boolean;
  setIsPercentualTopografia: (value: boolean) => void;
  isPercentualOutros: boolean;
  setIsPercentualOutros: (value: boolean) => void;
  isPercentualFrete: boolean;
  setIsPercentualFrete: (value: boolean) => void;
  bloquearDesconto: boolean;
  setBloquearDesconto: (value: boolean) => void;
  isFinanciado: boolean;
  setIsFinanciado: (value: boolean) => void;
  motivoOutros: string;
  setMotivoOutros: (valor: string) => void;
  triggerUpdateMaterial: () => void;
}

interface IPropostaMaterialAvulso {
  atividade: number;
  custoTotalImp: number | null;
  custoUnitario: number | null;
  custoUnitarioImp: number | null;
  id: number;
  quantidade: number;
  valor: number;
  valorTotal: number;
  material: Material;
}

interface IAgrupado {
  atividade: number;
  total: number;
  materiais: {
    atividade: number;
    custoTotalImp: number | null;
    custoUnitario: number | null;
    custoUnitarioImp: number | null;
    quantidade: number;
    valor: number;
    valorTotal: number;
    id: number;
    material: Material;
  }[];
}

export interface IMateriaisImportados {
  PropostaMaterialAvulso: IPropostaMaterialAvulso[];
  agrupado: IAgrupado[];
  createdAt: Date;
  data: Date;
  finalidade: string;
  nomeArquivo: string;
  rq: string;
  subtitulo: string;
  tipo: string;
  tipoImportacao: string;
  titulo: string;
  urlArquivo: string;
  id: number;
  total: number;
  valorTotal: number;
}

export interface PropostaMateriaisSelecao {
  id: number;
  desconto: number;
  isAvulso: boolean;
  isFaturamentoDireto: boolean;
  codigo: string;
  fabricanteDesc: string | null;
}

export const MateriaisContext = createContext({} as MateriaisContext);

const IDS_NAO_MOSTRAR_BOTOES = [2, 3];

function Materiais(): JSX.Element {
  const {
    propostaVersao,
    setPropostaVersao,
    setTriggerMaterialCheck,
    isMaterialValid,
    isObraExterior,
    meioPagamentos,
    permiteModificacao,
    meioPagamentoIdSelecionado,
    setMeioPagamentoIdSelecionado,
    carregaPropostaVersao,
    atualizarTelaProposta,
  } = useContext(PropostaContext);

  const [valorItens, setValorItens] = useState<number | null>(
    propostaVersao.valorItens,
  );
  const [valorFrete, setValorFrete] = useState<number | null | undefined>(
    propostaVersao.valorFrete,
  );
  const [valorFinal, setValorFinal] = useState<number | null>(
    propostaVersao.valorFinal,
  );
  const [valorServico, setValorServico] = useState<number | null>(
    propostaVersao.valorServico,
  );
  const [valorDesconto, setValorDesconto] = useState<number | null>(
    propostaVersao.valorDesconto,
  );
  const [valorFinalDolar, setValorFinalDolar] = useState<number | null>(
    propostaVersao.valorFinalDolar,
  );
  const [valorPercentualFrete, setValorPercentualFrete] = useState<
    number | null
  >(propostaVersao.percentualFrete);
  const [loadingMateriais, setLoadingMateriais] = useState(true);

  const [acessoLimitado, setAcessoLimitado] = useState(true);

  const [mostrarBotoes, setMostrarBotoes] = useState<boolean>(false);

  const [acessoLimitadoListaMateriais, setAcessoLimitadoListaMateriais] =
    useState(true);

  const [acessoLimitadoDescontoMaterial, setAcessoLimitadoDescontoMaterial] =
    useState({} as ValidarAcessoPrograma);

  const [totalSetorAtividadeAcesso, setTotalSetorAtividadeAcesso] = useState(
    {} as ValidarAcessoPrograma,
  );

  const [atualizarPrecificacao, setAtualizarPrecificacao] = useState(true);

  const [listaDescontoComissao, setListaDescontoComissao] = useState<
    PropostaDescontoComissao[]
  >([]);

  const [propostaConfiguracoes, setPropostaConfiguracoes] = useState<
    PropostaConfiguracao[]
  >([]);

  const [recalculandoProposta, setRecalculandoProposta] = useState(false);
  const [descontoSelecionado, setDescontoSelecionado] = useState<string | null>(
    '',
  );
  const [descontoMaximo, setDescontoMaximo] = useState<number | null>(null);
  const [valorLicenciamento, setValorLicenciamento] = useState<number>();
  const [valorTopografia, setValorTopografia] = useState<number>();
  const [valorOutros, setValorOutros] = useState<number>();
  const [isLicenciamentoPercentual, setIsLicenciamentoPercentual] =
    useState(false);
  const [isTopografiaPercentual, setIsTopografiaPercentual] = useState(false);
  const [isOutrosPercentual, setIsOutrosPercentual] = useState(false);
  const [isFretePercentual, setIsFretePercentual] = useState<boolean>(false);
  const [valorDolarCambial, setValorDolarCambial] = useState(0);
  const [valorDolarParametro, setValorDolarParametro] = useState(0);
  const [percentualAssistenciaTecnica, setPercentualAssistenciaTecnica] =
    useState(0);
  const [percentualTaxaFlat, setPercentualTaxaFlat] = useState(0);
  const [percentualComissao, setPercentualComissao] = useState(0);
  const [percentualAjusteComissao, setPercentualAjusteComissao] = useState(0);
  const [percentualIndicadorNegocio, setPercentualIndicadorNegocio] =
    useState(0);
  const [percentualComissaoReceber, setPercentualComissaoReceber] = useState(0);

  const [percentualServicos, setPercentualServicos] = useState(0);
  const [percentualICMS, setPercentualICMS] = useState(0);
  const [percentualPISCofins, setPercentualPISCofins] = useState(0);
  const [percentualIPI, setPercentualIPI] = useState(0);
  const [percentualST, setPercentualST] = useState(0);
  const [valorDespesaDespachante, setValorDespesaDespachante] = useState(0);
  const [valorSeguroFrete, setValorSeguroFrete] = useState(0);
  const [isSaveRequired, setIsSaveRequired] = useState(false);
  const [salvandoDifal, setSalvandoDifal] = useState(false);
  const [idBancoFinanciamentoSelecionado, setIdBancoFinanciamentoSelecionado] =
    useState<string>('');

  const [linhaCreditoSelecionado, setLinhaCreditoSelecionado] =
    useState<number>(0);
  const [formatoBancoSelecionado, setFormatoBancoSelecionado] = useState('');
  const [isPercentualLicenciamento, setIsPercentualLicenciamento] =
    useState(false);
  const [isPercentualTopografia, setIsPercentualTopografia] = useState(false);
  const [isPercentualOutros, setIsPercentualOutros] = useState(false);
  const [isPercentualFrete, setIsPercentualFrete] = useState(false);
  const [bloquearDesconto, setBloquearDesconto] = useState(false);
  const [isFinanciado, setIsFinanciado] = useState(false);
  const [motivoOutros, setMotivoOutros] = useState('');

  const [MateriaisImportados, setMateriaisImportados] = useState<
    IMateriaisImportados[]
  >([]);
  const [isFaturamentoDireto, setIsFaturamentoDireto] = useState(false);

  const [propostaMaterialSelecionado, setPropostaMaterialSelecionado] =
    useState<PropostaMateriaisSelecao[]>([]);

  const [mostrarSelecao, setMostrarSelecao] = useState(false);

  const [mostrarBotaoFat, setMostrarBotaoFat] = useState(false);
  const [prodMostrarBotaoFat, setProdMostrarBotaoFat] = useState(false);
  const [campoBusca, setCampoBusca] = useState('');
  const [fabricante, setFabricante] = useState<string[]>([]);
  const [formModalState, setFormModalState] = useState(false);
  const [descontoSelecao, setDescontoSelecao] = useState(0);
  const [habilitaSlideOpEspeciais, setHabilitaSlideOpEspeciais] =
    useState(false);
  const [salvandoDescontoLoading, setSalvandoDescontoLoading] = useState(false);
  const [precificacao, setPrecificacao] = useState([]);
  const queryClient = useQueryClient();

  async function mostrarBotao() {
    const response = await api.get(
      `/proposta/versao/mostrar-botao/${propostaVersao.id}`,
    );

    setMostrarBotaoFat(response.data);
  }

  async function getMateriaisImportados() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/material-importado`,
    );

    return response.data;
  }
  const { data: dataMateriaisImportados, isLoading } = useQuery(
    ['proposta-configuracao-materiais-importados', propostaVersao.id],
    async () => {
      const data = await getMateriaisImportados();
      console.log(data);
      return data;
    },
  );

  async function getOpcaoMostrarBotoes(
    propostaConfiguracaoArray: PropostaConfiguracao[],
  ) {
    if (!propostaConfiguracaoArray) return;
    const response = await api.get(`/produto/configuracao/lista`, {
      params: {
        ids: propostaConfiguracaoArray.map(item => item.orcamentoId)?.join(','),
      },
    });

    const opBotoes: number[] = response.data.map(
      (item: any) => item.opcaoMostrarBotoes,
    );

    const resultado = OpcaoMostrarBotoes.filter(opcao =>
      opBotoes.includes(opcao.id),
    );

    setMostrarBotoes(
      resultado.some(result => IDS_NAO_MOSTRAR_BOTOES.includes(result.id)),
    );
  }

  async function getMostrarBtnFatDireto(
    propostaConfiguracaoArray: PropostaConfiguracao[],
  ) {
    if (!propostaConfiguracaoArray) return;
    const response = await api.get(`/produto/mostrar-btn-fat`, {
      params: {
        ids: propostaConfiguracaoArray.map(item => item.orcamentoId)?.join(','),
      },
    });

    setProdMostrarBotaoFat(response.data);
  }

  async function buscarMateriaisImportados() {
    const dados = await getMateriaisImportados();
    setMateriaisImportados(dados);
  }

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 28,
      },
    });
    setAcessoLimitado(response.data);

    const response2 = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 60,
      },
    });
    setAcessoLimitadoListaMateriais(response2.data);

    const descontoMaterialAcesso = await api.get(
      '/acesso-programa/acesso-programa',
      {
        params: {
          programaId: 129,
        },
      },
    );

    const totalSetorAtivAcesso = await api.get(
      '/acesso-programa/acesso-programa',
      {
        params: {
          programaId: 137,
        },
      },
    );

    setTotalSetorAtividadeAcesso(totalSetorAtivAcesso.data);
    setAcessoLimitadoDescontoMaterial(descontoMaterialAcesso.data);
  }

  useEffect(() => {
    getAcessoLimitadoPrograma();
  }, []);

  async function buscarConfiguracoes() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/configuracoes`,
    );

    setPropostaConfiguracoes(response.data);

    getOpcaoMostrarBotoes(response.data);
    getMostrarBtnFatDireto(response.data);
  }

  /* useEffect(() => {
    async function carregarListaPreco() {
      const response = await api.get(
        `/proposta/versao/${propostaVersao.id}/validar-precos`,
      );
      setPrecosDesatualizados(response.data.desatualizado ?? false);
    }
    carregarListaPreco();
  }, []); */

  async function buscarListaDescontos() {
    const response2 = await api.get(
      `/proposta-perfil-aprovacao/min-max-desconto/${propostaVersao.id}`,
    );

    setDescontoMaximo(response2.data?.descontoMaximo ?? 0);
  }

  async function pegarFabricantes() {
    const ids = propostaConfiguracoes.map(item => item.orcamentoId);
    try {
      const response = await api.get(`/proposta/configuracao/fabricante`, {
        params: { ids },
      });

      const fabr = response.data;
      setFabricante(fabr);
    } catch (error) {
      console.log(error);
    }
  }

  async function filtroTabela(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const search = event.target.value;

    setCampoBusca(search);
  }

  async function recalculaProposta(isAtingirMeta?: boolean | undefined) {
    try {
      setValorPercentualFrete(0);
      setRecalculandoProposta(true);
      Swal.fire({
        icon: 'info',
        text: `Recalculando proposta...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      const response = await api.post(
        `/proposta/versao/${propostaVersao.id}/recalcular`,
        {
          isAtingirMeta:
            isAtingirMeta !== undefined && isAtingirMeta !== null
              ? isAtingirMeta
              : false,
        },
      );
      const data = response.data as PropostaVersao;
      setValorItens(data.valorItens);
      setValorFrete(data.percentualFrete);
      setValorFinal(data.valorFinal);
      /*
      setValorFinalSemDesconto(
        data.precificacao?.reduce(
          (acc, item) => acc + item.valorFinalSemDesconto,
          0,
        ),
      );
       */
      setValorFinalDolar(data.valorFinalDolar);

      setValorServico(data.valorServico);
      setValorDesconto(data.valorDesconto);
      setValorPercentualFrete(data.percentualFrete);
    } catch (error: any) {
      throw new Error(error?.response?.data?.message);
    }
  }

  async function atualizarProposta() {
    Swal.fire({
      icon: 'info',
      text: `Atualizando informações da proposta`,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });

    try {
      await api.post(`/proposta/versao/${propostaVersao.id}/reprocessar`);

      Swal.close();
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    }
  }

  async function triggerUpdateMaterial() {
    await atualizarProposta();
    await recalculaProposta();

    await buscarMateriaisImportados();
    setTriggerMaterialCheck(true);

    setRecalculandoProposta(false);
    Swal.close();
    toast.success('Proposta atualizada');
  }

  async function carregaDadosPercentuais() {
    const response = await api.get(
      `/proposta-precificacao/versao/${propostaVersao.id}`,
    );

    const prec = response.data?.precificacao;
    setPrecificacao(prec);

    if (!prec) {
      return;
    }

    const {
      percentualLicenciamento,
      percentualTopografia,
      percentualOutros,
      percentualFrete,
      valorLicenciamento: valorLicenciamentoData,
      valorTopografia: valorTopografiaData,
      valorOutros: valorOutrosData,
      valorFrete: valorFreteData,
    } = prec;

    setValorLicenciamento(percentualLicenciamento ?? valorLicenciamentoData);
    setValorTopografia(percentualTopografia ?? valorTopografiaData);
    setValorOutros(percentualOutros ?? valorOutrosData);
    setValorFrete(percentualFrete); // Fixando em percentual, por enquanto

    setIsLicenciamentoPercentual(Boolean(percentualLicenciamento));
    setIsTopografiaPercentual(Boolean(percentualTopografia));
    setIsOutrosPercentual(Boolean(percentualOutros));
    setIsFretePercentual(true); // POr conta de bug, vamos fixar em percentual apenas por enquanto

    setPercentualAssistenciaTecnica(prec.percentualAssistenciaTecnica);
    setPercentualComissao(prec.percentualComissao);
    setPercentualAjusteComissao(prec.percentualAjusteComissao);
    setPercentualIndicadorNegocio(prec.percentualIndicadorNegocio);
    setPercentualComissaoReceber(prec.percentualComissaoReceber);
    setPercentualServicos(prec.percentualServicos); // setPercentualServicos(prec.percentualServicos ?? 3);
    setPercentualTaxaFlat(prec.percentualTaxaFlat);
    setPercentualICMS(prec.percentualICMS);
    setPercentualPISCofins(prec.percentualPISCofins);
    setPercentualIPI(prec.percentualIPI);
    setPercentualST(prec.percentualST);
    setPercentualST(prec.percentualST);
    setMotivoOutros(prec.motivoOutros ?? '');

    if (isObraExterior) {
      setValorDespesaDespachante(prec.valorDespesaDespachante);
      setValorDolarCambial(prec.valorDolar);
      setValorSeguroFrete(prec.valorSeguroFrete);
    }

    setAtualizarPrecificacao(false);
  }

  async function updateStatus() {
    try {
      Swal.fire({
        icon: 'info',
        text: `Trocando para faturamento direto...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      // Enviando a alteração para status 9 - Escopo Concluído
      const retorno = await api.put(
        `proposta/versao/${propostaVersao.id}/status/9`,
        {
          isFaturamentoDireto: true,
        },
      );

      const dados: Dados = retorno.data;

      if (dados.aprovacaoNecessaria) {
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          text: `A validação encontrou uma necessidade de aprovação, para concluir essa operação de exclusão.`,
          confirmButtonText: `Ok`,
        });
      } else {
        toast.success(`Status alterado para escopo concluído.`, {
          position: 'top-right',
        });
        Swal.close();
      }

      // Atualizar a tela
      await carregaPropostaVersao();
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    }
  }

  async function salvarFatDireto() {
    const confirmacao = await Swal.fire({
      title: `Atenção`,
      html: `<div>Será necessário passar por um processo de aprovação.</div>
      <div>Deseja prosseguir?</div>`,
      icon: 'warning',
      confirmButtonText: `Sim, prosseguir`,
      cancelButtonText: `Não`,
      showCancelButton: true,
    });

    if (!confirmacao.isConfirmed) {
      return;
    }

    toast.loading('Aguarde...');
    const { listaMat, listaAvulsos } = propostaMaterialSelecionado.reduce(
      (acc, item) => {
        if (item.isAvulso)
          acc.listaAvulsos.push({
            id: item.id,
            desconto: item?.desconto ?? 0,
            isAvulso: item.isAvulso,
            isFaturamentoDireto: item.isFaturamentoDireto,
            codigo: item.codigo,
            fabricanteDesc: item.fabricanteDesc,
          });
        else
          acc.listaMat.push({
            id: item.id,
            desconto: item?.desconto ?? 0,
            isAvulso: item.isAvulso,
            isFaturamentoDireto: item.isFaturamentoDireto,
            codigo: item.codigo,
            fabricanteDesc: item.fabricanteDesc,
          });
        return acc;
      },
      {
        listaMat: [] as typeof propostaMaterialSelecionado,
        listaAvulsos: [] as typeof propostaMaterialSelecionado,
      },
    );

    const listaIds = listaMat.map(item => item.id);
    const listaIdsAvulsosImportados = listaAvulsos.map(item => item.id);
    // const listaIdsImportados = [...checkedIdsImportados];
    // const listaIdsFiltrada = listaIds.filter(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // item => !listaMatExcluidosVersaoAnteriorOriginal.includes(item),
    // );

    const response = await api.post(
      `/proposta/versao/${propostaVersao.id}/fat-direto`,
      { listaIds, listaIdsAvulsosImportados },
    );

    toast.dismiss();
    updateStatus();

    setIsFaturamentoDireto(false);

    setPropostaMaterialSelecionado([]);
  }

  async function mostrarDescontoModal() {
    setFormModalState(true);
  }
  async function salvarDesconto() {
    toast.loading('Salvando desconto');
    setSalvandoDescontoLoading(true);
    const response = await api.post(
      `/proposta/versao/${propostaVersao.id}/material/desconto`,
      {
        propostaMaterialSelecionado: propostaMaterialSelecionado.map(item => ({
          ...item,
          desconto: descontoSelecao,
        })),
      },
    );

    toast.dismiss();
    setFormModalState(false);
    setPropostaMaterialSelecionado([]);
    setCampoBusca('');
    setMostrarSelecao(false);

    await triggerUpdateMaterial();
    propostaConfiguracoes.map(pc => {
      queryClient.invalidateQueries([
        `proposta-configuracao-materiais-${pc.id}`,
      ]);
      return null;
    });

    //
    Swal.fire({
      icon: 'info',
      text: `Atualizando dados...`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
    await buscarConfiguracoes();
    // await buscarMateriaisImportados();
    Swal.close();
    setSalvandoDescontoLoading(false);
  }

  useEffect(() => {
    if (atualizarPrecificacao === true) carregaDadosPercentuais();
  }, [atualizarPrecificacao]);

  useEffect(() => {
    buscarListaDescontos();
    buscarConfiguracoes();
    buscarMateriaisImportados();
    mostrarBotao();
  }, []);

  useEffect(() => {
    if (propostaConfiguracoes && propostaConfiguracoes.length) {
      pegarFabricantes();
    }
  }, [propostaConfiguracoes]);

  function verificarAcessoAFatDirDesconto() {
    const temAcessoFat = !(
      propostaVersao.pvcPorContaCliente ||
      !mostrarBotaoFat ||
      !prodMostrarBotaoFat
    );

    const temAcessoDesconto = acessoLimitadoDescontoMaterial.temAcesso;

    if (temAcessoFat && temAcessoDesconto) {
      setIsFaturamentoDireto(true);
      setHabilitaSlideOpEspeciais(true);
    } else if (temAcessoFat) {
      setIsFaturamentoDireto(true);
      setHabilitaSlideOpEspeciais(false);
    } else {
      setIsFaturamentoDireto(false);
      setHabilitaSlideOpEspeciais(false);
    }
  }

  useEffect(() => {
    verificarAcessoAFatDirDesconto();
  }, [acessoLimitadoDescontoMaterial, mostrarBotaoFat, prodMostrarBotaoFat]);

  /**
   *
  useEffect(() => {
    if (propostaConfiguracoes && propostaConfiguracoes.length > 0)
    getOpcaoMostrarBotoes();
  }, [propostaConfiguracoes]);
  */

  async function callBackConfiguracoes() {
    buscarConfiguracoes();
  }

  async function handleFiltroFabricante(
    e: SingleValue<{
      label: string;
      value: string;
    }>,
  ) {
    const fabrDesc =
      propostaMaterialSelecionado.find(fab => fab.fabricanteDesc)
        ?.fabricanteDesc ?? null;
    if (
      e?.label &&
      fabrDesc &&
      e.label !== '' &&
      String(fabrDesc).toLowerCase() !== e?.label.toLowerCase()
    ) {
      const confirmacao = await Swal.fire({
        title: `Atenção`,
        html: `<div>Ao trocar de fabricante, todos os itens marcados do fabricante ${fabrDesc} serão desmarcados, deseja continuar?</div>`,
        icon: 'warning',
        confirmButtonText: `Sim, prosseguir`,
        cancelButtonText: `Não`,
        showCancelButton: true,
      });

      if (!confirmacao.isConfirmed) {
        return;
      }
    }

    if (e?.label && String(fabrDesc).toLowerCase() !== e?.label.toLowerCase()) {
      setPropostaMaterialSelecionado([]);
      /**
       *
      setPropostaMaterialSelecionado(prev => {
        return prev.filter(
          val => val.fabricanteDesc === null || val.fabricanteDesc !== e.label,
        );
      });
      */
    }
    setCampoBusca(e ? e.label : '');
  }

  return (
    <MateriaisContext.Provider
      value={{
        valorItens,
        valorFrete,
        valorFinal,
        valorFinalDolar,
        setValorItens,
        setValorFrete,
        setValorFinal,
        setValorServico,
        setValorDesconto,
        setValorPercentualFrete,
        setValorFinalDolar,
        loadingMateriais,
        setLoadingMateriais,
        setTriggerMaterialCheck,
        isMaterialValid,
        acessoLimitado,
        listaDescontoComissao,
        atualizarPrecificacao,
        setAtualizarPrecificacao,
        recalculandoProposta,
        setRecalculandoProposta,
        descontoSelecionado,
        setDescontoSelecionado,
        descontoMaximo,
        setDescontoMaximo,
        valorLicenciamento,
        setValorLicenciamento,
        valorTopografia,
        setValorTopografia,
        valorOutros,
        setValorOutros,
        isLicenciamentoPercentual,
        setIsLicenciamentoPercentual,
        isTopografiaPercentual,
        setIsTopografiaPercentual,
        isOutrosPercentual,
        setIsOutrosPercentual,
        isFretePercentual,
        setIsFretePercentual,
        valorDolarCambial,
        setValorDolarCambial,
        valorDespesaDespachante,
        setValorDespesaDespachante,
        valorSeguroFrete,
        setValorSeguroFrete,
        valorDolarParametro,
        setValorDolarParametro,
        percentualAssistenciaTecnica,
        setPercentualAssistenciaTecnica,
        percentualTaxaFlat,
        setPercentualTaxaFlat,
        percentualComissao,
        setPercentualComissao,
        percentualAjusteComissao,
        setPercentualAjusteComissao,
        percentualIndicadorNegocio,
        setPercentualIndicadorNegocio,
        percentualComissaoReceber,
        setPercentualComissaoReceber,
        percentualServicos,
        setPercentualServicos,
        percentualICMS,
        setPercentualICMS,
        percentualPISCofins,
        setPercentualPISCofins,
        percentualIPI,
        setPercentualIPI,
        percentualST,
        setPercentualST,
        isSaveRequired,
        setIsSaveRequired,
        salvandoDifal,
        setSalvandoDifal,
        idBancoFinanciamentoSelecionado,
        setIdBancoFinanciamentoSelecionado,
        linhaCreditoSelecionado,
        setLinhaCreditoSelecionado,
        formatoBancoSelecionado,
        setFormatoBancoSelecionado,
        isPercentualLicenciamento,
        setIsPercentualLicenciamento,
        isPercentualTopografia,
        setIsPercentualTopografia,
        isPercentualOutros,
        setIsPercentualOutros,
        isPercentualFrete,
        setIsPercentualFrete,
        bloquearDesconto,
        setBloquearDesconto,
        isFinanciado,
        setIsFinanciado,
        motivoOutros,
        setMotivoOutros,
        triggerUpdateMaterial,
      }}
    >
      {!isMaterialValid && (
        <Row className="mb-4">
          <Col sm="12" xs="12">
            <Alert color="danger">
              Uma ou mais configurações associadas possuem materiais sem valor.
              Algumas ações estarão bloqueadas até a resolução do valor dos
              materiais. <br />
              Será necessário aguardar, a equipe de Engenharia já foi notificada
              e estão avaliando.
            </Alert>
          </Col>
        </Row>
      )}
      <Row className="mb-4">
        <Col sm="12">
          {mostrarBotoes && (
            <>
              <ImportarExcel
                propostaVersaoId={propostaVersao.id}
                tipo="Telemetria"
                opcoes={Opcoes.Proposta}
              />
              <ImportarExcel
                propostaVersaoId={propostaVersao.id}
                tipo="BM"
                opcoes={Opcoes.Proposta}
              />
              <ImportarExcel
                propostaVersaoId={propostaVersao.id}
                tipo="Outros"
                carregarFinalidade
                opcoes={Opcoes.Proposta}
              />
            </>
          )}
        </Col>
      </Row>

      <Row className="mb-4 align-items-center px-2">
        <Col sm="3" xs="8" className="d-flex align-items-center">
          <Button
            size="sm"
            className="btn-icon btn-2 me-2"
            color="default"
            hidden={
              (propostaVersao.pvcPorContaCliente ||
                !mostrarBotaoFat ||
                !prodMostrarBotaoFat) &&
              !acessoLimitadoDescontoMaterial.temAcesso
            }
            type="button"
            onClick={() => {
              setMostrarSelecao(prev => {
                if (prev === true) {
                  setPropostaMaterialSelecionado([]);
                }
                return !prev;
              });
              // setIsFaturamentoDireto(prev => !prev);
            }}
          >
            Operações especiais
          </Button>

          {propostaMaterialSelecionado.length > 0 &&
            mostrarSelecao &&
            (!mostrarBotaoFat ||
              !prodMostrarBotaoFat ||
              (!propostaVersao.pvcPorContaCliente && isFaturamentoDireto && (
                <>
                  <FloatingButton
                    title="Salvar faturamento direto"
                    onClick={salvarFatDireto}
                  >
                    <FaCheckCircle />
                  </FloatingButton>
                </>
              )))}
          {propostaMaterialSelecionado.length > 0 &&
            mostrarSelecao &&
            !isFaturamentoDireto && (
              <>
                <FloatingButton
                  title="Salvar desconto"
                  onClick={mostrarDescontoModal}
                >
                  <FaCheckCircle />
                </FloatingButton>
              </>
            )}
        </Col>

        <Col sm="4" xs="8" className="d-flex align-items-center pt-2">
          <FormGroup className="w-100">
            <Select
              className="w-100 select-align-middle"
              closeMenuOnSelect={false}
              placeholder="Selecione..."
              isSearchable
              isClearable
              options={fabricante.map(item => ({ label: item, value: item }))}
              onChange={handleFiltroFabricante}
              value={
                campoBusca ? { label: campoBusca, value: campoBusca } : null
              }
            />
          </FormGroup>
        </Col>

        <Col
          sm="2"
          xs="5"
          className="d-flex align-items-center justify-content-end"
        >
          <DownloadPlanilha
            className="float-right"
            acessoLimitado={acessoLimitadoListaMateriais}
            propostaConfiguracoes={propostaConfiguracoes}
          />
        </Col>
      </Row>

      <Row>
        <Modal
          className="modal-dialog-centered"
          size="md"
          isOpen={formModalState}
          toggle={() => setFormModalState(!formModalState)}
          backdrop={salvandoDescontoLoading ? 'static' : true}
          keyboard={!salvandoDescontoLoading}
        >
          <Card
            className="shadow border-0 rounded-3 p-2"
            style={{ minHeight: '260px' }}
          >
            <CardHeader className="bg-white border-0 text-center pb-0">
              <h5 className="mb-1 text-dark fw-bold">Aplicar desconto</h5>
              <p className="text-muted small mb-0">
                Este desconto será aplicado a todos os materiais marcados.
              </p>
            </CardHeader>

            <ModalBody className="px-4 pb-4 pt-3">
              <FormGroup className="mb-4 text-center">
                <div
                  className="d-flex align-items-center justify-content-center gap-2"
                  style={{ marginTop: '10px' }}
                >
                  <label
                    htmlFor="desconto"
                    className="fw-semibold mb-0 mr-2"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    Desconto (%):
                  </label>
                  <TextField
                    id="desconto"
                    type="number"
                    variant="standard"
                    value={descontoSelecao}
                    onChange={e => setDescontoSelecao(Number(e.target.value))}
                  />
                </div>
              </FormGroup>

              <div className="d-flex justify-content-end mt-4">
                <Button
                  color="secondary"
                  outline
                  disabled={salvandoDescontoLoading}
                  onClick={() => setFormModalState(false)}
                  className="me-2"
                >
                  Cancelar
                </Button>
                <Button
                  color="primary"
                  disabled={salvandoDescontoLoading}
                  onClick={salvarDesconto}
                >
                  Salvar
                </Button>
              </div>
            </ModalBody>
          </Card>
        </Modal>
      </Row>

      <Row className="px-2 flex justify-center justify-content-center p-2 d-flex align-items-center">
        <Col sm="6" hidden={!mostrarSelecao}>
          <FormGroup className="">
            <InputGroup className="input-group-alternative justify-content-center p-2 d-flex align-items-center">
              <span
                className={`ml-2 ${!isFaturamentoDireto && 'campo-desativado'}`}
              >
                Faturamento Direto
              </span>
              <label className="custom-toggle mr-2 ml-2">
                <input
                  type="checkbox"
                  checked={
                    !acessoLimitadoDescontoMaterial.temAcesso
                      ? false
                      : !isFaturamentoDireto
                  }
                  disabled={!habilitaSlideOpEspeciais}
                  onChange={e => {
                    setIsFaturamentoDireto(prev => !prev);
                  }}
                />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
              <span
                className={`mr-2 ${isFaturamentoDireto && 'campo-desativado'}`}
              >
                Desconto (%)
              </span>
            </InputGroup>
          </FormGroup>
        </Col>
      </Row>

      {propostaConfiguracoes.map(propostaConfiguracao => (
        <PropostaConfiguracaoMaterial
          key={propostaConfiguracao.id}
          propostaConfiguracao={propostaConfiguracao}
          atualizar={callBackConfiguracoes}
          isFaturamentoDireto={isFaturamentoDireto}
          campoBusca={campoBusca}
          setPropostaMaterialSelecionado={setPropostaMaterialSelecionado}
          propostaMaterialSelecionado={propostaMaterialSelecionado}
          mostrarSelecao={mostrarSelecao}
          precificacao={precificacao}
          totalSetorAtividadeAcesso={totalSetorAtividadeAcesso}
        />
      ))}

      <PropostaMaterialAvulso
        isFaturamentoDireto={isFaturamentoDireto}
        campoBusca={campoBusca}
        setPropostaMaterialSelecionado={setPropostaMaterialSelecionado}
        propostaMaterialSelecionado={propostaMaterialSelecionado}
        mostrarSelecao={mostrarSelecao}
      />

      <PropostaMaterialImportado
        materiaisImportados={MateriaisImportados ?? []}
        propostaVersaoId={propostaConfiguracoes[0]?.propostaVersaoId}
        isFaturamentoDireto={isFaturamentoDireto}
        campoBusca={campoBusca}
        setPropostaMaterialSelecionado={setPropostaMaterialSelecionado}
        propostaMaterialSelecionado={propostaMaterialSelecionado}
        mostrarSelecao={mostrarSelecao}
      />
    </MateriaisContext.Provider>
  );
}

export default Materiais;
